/**
 * @freesewing/plugin-svgattr | v2.18.0
 * A FreeSewing plugin to set SVG attributes
 * (c) 2021 Joost De Cock <joost@joost.at> (https://github.com/joostdecock)
 * @license MIT
 */
var name = "@freesewing/plugin-svgattr";
var version = "2.18.0";

var index = {
  name: name,
  version: version,
  hooks: {
    preRender: function (svg, attributes) {
      if (svg.attributes.get('freesewing:plugin-svgattr') === false) {
        for (let key of Object.keys(attributes)) svg.attributes.add(key, attributes[key]);
        svg.attributes.add('freesewing:plugin-svgattr', version);
      }
    },
  },
};

export { index as default };
//# sourceMappingURL=index.mjs.map
